import {useEffect} from 'react';
import {COLUMN_CRUMB, HOME_CRUMB} from '../../../../../config/constants/crumb';
import {GoogleAdBannerName} from '../../../../../config/constants/googleAdBanner';
import {HOME} from '../../../../../config/constants/routes';
import {GoogleAdBanner} from '../../../../../shared/components/Banner/GoogleAdBanner';
import type {Breadcrumb} from '../../../../../shared/components/BreadcrumbsComponent';
import {useGoogleAdBanner} from '../../../../../shared/services/useGoogleAdBanner';
import {useMediaQuery} from '../../../../../shared/services/useMediaQuery';
import {Header} from '../Header';
import {COLUMNS_TOP} from '../routes';
import {Carousels} from './Carousels';

const breadcrumbs: Breadcrumb[] = [
  {label: HOME_CRUMB, href: HOME},
  {label: COLUMN_CRUMB, href: COLUMNS_TOP},
];

export const ColumnListTopPage: React.FC = () => {
  const {isPC} = useMediaQuery();
  const googleAdBannerNames = [GoogleAdBannerName.RICH_DESKTOP_HEADER];
  const {setShouldRefetch} = useGoogleAdBanner(googleAdBannerNames);

  useEffect(() => {
    setShouldRefetch(true);
  }, [setShouldRefetch]);

  return (
    <>
      <div className="hidden pc:flex justify-center">
        <GoogleAdBanner
          googleAdBannerName={GoogleAdBannerName.RICH_DESKTOP_HEADER}
        />
      </div>
      <Header
        breadcrumbs={breadcrumbs}
        title="コラム"
        description={`外資系金融・コンサル・商社・外資メーカーなど、トップ企業志望者必見のコラムを幅広く掲載。${isPC ? '現役社員・内定者の体験談、実践的な選考ノウハウを通し、志望企業の内定獲得につなげよう！' : ''}`}
      />
      <Carousels />
    </>
  );
};
